import { ColorOptions } from './color-options';
import { GridCellContentAlignment } from '@grid/enums';
import { IAutoFocus, NumericInputOptions } from '.';

export interface NumericCellConfig extends IAutoFocus {
  options?: NumericInputOptions;
  alignment?: GridCellContentAlignment;
  colorOptions?: ColorOptions;
}
